/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedTaskLogLabelUpdateRequest,
  TaskLogLabelCreateRequest,
  TaskLogLabelReorderRequest,
  TaskLogLabelWithCount
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type taskLogLabelsListResponse200 = {
  data: TaskLogLabelWithCount[]
  status: 200
}

export type taskLogLabelsListResponseSuccess = (taskLogLabelsListResponse200) & {
  headers: Headers;
};
;

export type taskLogLabelsListResponse = (taskLogLabelsListResponseSuccess)

export const getTaskLogLabelsListUrl = () => {




  return `/api/v1/task-log-labels/`
}

export const taskLogLabelsList = async ( options?: RequestInit): Promise<taskLogLabelsListResponse> => {

  return customFetch<taskLogLabelsListResponse>(getTaskLogLabelsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type taskLogLabelsCreateResponse201 = {
  data: TaskLogLabelWithCount[]
  status: 201
}

export type taskLogLabelsCreateResponseSuccess = (taskLogLabelsCreateResponse201) & {
  headers: Headers;
};
;

export type taskLogLabelsCreateResponse = (taskLogLabelsCreateResponseSuccess)

export const getTaskLogLabelsCreateUrl = () => {




  return `/api/v1/task-log-labels/`
}

export const taskLogLabelsCreate = async (taskLogLabelCreateRequest: TaskLogLabelCreateRequest, options?: RequestInit): Promise<taskLogLabelsCreateResponse> => {

  return customFetch<taskLogLabelsCreateResponse>(getTaskLogLabelsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskLogLabelCreateRequest)
  }
);}


export type taskLogLabelsPartialUpdateResponse200 = {
  data: TaskLogLabelWithCount[]
  status: 200
}

export type taskLogLabelsPartialUpdateResponseSuccess = (taskLogLabelsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type taskLogLabelsPartialUpdateResponse = (taskLogLabelsPartialUpdateResponseSuccess)

export const getTaskLogLabelsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/task-log-labels/${id}/`
}

export const taskLogLabelsPartialUpdate = async (id: string,
    patchedTaskLogLabelUpdateRequest?: PatchedTaskLogLabelUpdateRequest, options?: RequestInit): Promise<taskLogLabelsPartialUpdateResponse> => {

  return customFetch<taskLogLabelsPartialUpdateResponse>(getTaskLogLabelsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedTaskLogLabelUpdateRequest)
  }
);}


export type taskLogLabelsArchiveCreateResponse200 = {
  data: TaskLogLabelWithCount[]
  status: 200
}

export type taskLogLabelsArchiveCreateResponseSuccess = (taskLogLabelsArchiveCreateResponse200) & {
  headers: Headers;
};
;

export type taskLogLabelsArchiveCreateResponse = (taskLogLabelsArchiveCreateResponseSuccess)

export const getTaskLogLabelsArchiveCreateUrl = (id: string,) => {




  return `/api/v1/task-log-labels/${id}/archive/`
}

/**
 * Past updates keep the label; it only drops out of the picker.
 */
export const taskLogLabelsArchiveCreate = async (id: string, options?: RequestInit): Promise<taskLogLabelsArchiveCreateResponse> => {

  return customFetch<taskLogLabelsArchiveCreateResponse>(getTaskLogLabelsArchiveCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type taskLogLabelsReorderCreateResponse200 = {
  data: TaskLogLabelWithCount[]
  status: 200
}

export type taskLogLabelsReorderCreateResponseSuccess = (taskLogLabelsReorderCreateResponse200) & {
  headers: Headers;
};
;

export type taskLogLabelsReorderCreateResponse = (taskLogLabelsReorderCreateResponseSuccess)

export const getTaskLogLabelsReorderCreateUrl = () => {




  return `/api/v1/task-log-labels/reorder/`
}

export const taskLogLabelsReorderCreate = async (taskLogLabelReorderRequest: TaskLogLabelReorderRequest, options?: RequestInit): Promise<taskLogLabelsReorderCreateResponse> => {

  return customFetch<taskLogLabelsReorderCreateResponse>(getTaskLogLabelsReorderCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(taskLogLabelReorderRequest)
  }
);}


